import { GET, PATCH, POST, DELETE } from "../../helper/xbi4RestFunctions";
export const removePeopleLead = async (
  org_id: any,
  org_user_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/RemovePeopleLead?kalutha=${data?.org_user_id}`;
  return await DELETE(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error in creating people lead >", err);
      return err;
    });
};
